import React, { useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import api from "../../api/api";
import dollarImage from "../../../src/assets/Signin/Dollar.svg";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import cancelledDesk from "../../../src/assets/Signin/FrontCancel.svg";
import ConfirmFrontdesk from "../../signin/popups/ConfirmFrontdesk";
import { retrive } from "./svg";
import InsurancePlansModal from "../../landingscreen/modals/insuranceplanmodal";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../reduxtoolkit/toastslice";
import { Backdrop, CircularProgress } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
const Payment = ({ closeAllModals, data }) => {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState("payment");
  const [loading, setLoading] = useState(false);
  const [PaymentMethod, setPaymentMethod] = useState([]);
    const[loader,setLoader]=useState(false)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [copay, setCopay] = useState(0.0);
  const [selfPay, setSelfPay] = useState(0.0);
  const [coinsurance, setCoinsurance] = useState(0.0);
  const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const userConfig = useSelector((state) => state.userconfig);
  const [deductible, setDeductible] = useState(0.0);
  const [totalAmount, setTotalAmount] = useState(0.0);
  const [paymentOnAccount, setPaymentOnAccount] = useState("");
  const [ccnumber, setCcnumber] = useState("");
  const loginUser = localStorage.getItem("user");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [alertmessage, setAlertMessage] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedTab, setSelectedTab] = useState("");
  const [isFrontDesk, setIsFrontDesk] = useState(null);
  const [frontdeskModal, setfrontdeskModal] = useState(false);
  const [getpaymentData, setGetpaymentData] = useState(null);
    const [showPaymentsHistory, setShowPaymentsHistory] = useState(false);
  const [frontDesk, setFrontDesk] = useState("");
  const navigate = useNavigate();
  const practiseid = window.getPracticeId();
 const[prevamount,setPrevamount]=useState('')
  const dispatch = useDispatch();

  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (data) {
      // Make sure data is available before calling the function
      handleGetPayment({ data });
    } else {
      console.error("Data is not available yet");
    }
  }, [data]);

  useEffect(() => {
    fetchFrontDesk();
  }, [data]);

  useEffect(() => {
    if (userConfig?.grole == 2 || userConfig?.grole == 3) {
      setActiveTab("update"); // Pay tab
    } else {
      setActiveTab("payment"); // Update tab
    }
  }, [userConfig]);

  const handleGetPayment = async ({ data }) => {
    setLoader(true)
    const dateString = data.startdate; // example response: "2025-03-28T15:45:00"
    const formattedDate = new Date(dateString).toLocaleDateString("en-CA");
    try {
      const response = await api.post(
        `/v1/${practiseid}/patient/${data?.patientid}/view-payments`,
        {
          appointmentid: data.appointmentid,
          startdate: formattedDate,
        },
      );
      if (response.status === 200) {
        setGetpaymentData(response.data);
      } else {
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    }finally{
      setLoader(false)
    }
  };
const fetchprevamount = async () => {
  try {
    const response = await api.post(
      `/v1/${practiseid}/patient/${data.patientid}/appointment/payment-details`,
      {
        appointmentid: data.appointmentid,
        startdate: dayjs().format("YYYY-MM-DD"),
      }
    );

     if (response.status === 200) {
      const payments = response?.data;
  setPrevamount(payments)
    } else {
      setPrevamount([]);
    }
  } catch (error) {
    console.log(error);
    setPrevamount(0);
  }
};
  const fetchFrontDesk = async () => {
    setLoading(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/appointments/patient/${data.patientid}/get_front_desk`,
        {
          appointmentid: data.appointmentid,
        },
      );
      if (response.status === 200) {
        setIsFrontDesk(response); //
      } else {
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUpdateFrontDesk = async ({ frontDesk, data }) => {
    setLoading(true);
    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${data.patientid}/front_desk`,
        {
          appointmentid: data.appointmentid,
          is_front_desk: frontDesk,
        },
      );
      if (response.status === 200) {
        fetchData();
      } else {
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFrontDeskToggle = () => {
    // Toggle the frontDesk state between "Y" and "N"
    const newStatus = frontDesk === "Y" ? "N" : "Y";

    // Set the new status in state
    setFrontDesk(newStatus);

    // Call the fetchUpdateFrontDesk function with the new front desk value
    fetchUpdateFrontDesk({ frontDesk: newStatus, data });
  };

  const hanldeFrontdeskModal = () => {
    setfrontdeskModal(true);
  };

  useEffect(() => {
    // Calculate the initial total amount (before coinsurance adjustment)
    const initialTotal =
      (parseFloat(copay) || 0.0) +
      (parseFloat(selfPay) || 0.0) +
      (parseFloat(paymentOnAccount) || 0.0);

    let totalAfter = initialTotal;

    // Apply coinsurance percentage to the total amount if there is coinsurance
    if (coinsurance) {
      totalAfter = initialTotal - (parseFloat(deductible) || 0.0); // Subtract deductible if coinsurance exists
      // After applying coinsurance, set deductible to 0
      setDeductible(0);
    }

    // Set the total amount after applying the coinsurance adjustment
    setTotalAmount(totalAfter.toString());
  }, [copay, selfPay, paymentOnAccount, deductible, coinsurance]);

  const fetchData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await api.get(
        `/v1/${practiseid}/payments/payment-methods`,
      );
      if (response.status === 200) {
        setPaymentMethod(response.data);
      } else {
        setPaymentMethod([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchData();
    fetchprevamount()
  }, []);

  const handleCcnumberChange = (e) => {
    setCcnumber(e.target.value);
  };

  useEffect(() => {
    if (getpaymentData && activeTab === "payment") {
      // If `getpaymentData` exists, populate the form fields with its values
      setCopay(getpaymentData.copay || 0.0);
      setSelfPay(getpaymentData.selfpay || 0.0);
      setDeductible(getpaymentData.deductibleamt || 0.0);
      setPaymentOnAccount(getpaymentData.acctbalance || 0.0);
      // Ensure totalAmount is calculated or set correctly
    } else if (activeTab === "update") {
      // Optionally reset these when switching to the update tab as well.
      setCopay("");
      setSelfPay("");
      setPaymentOnAccount("");
      setCoinsurance("");
      setDeductible("");
      setTotalAmount("0");
    }
  }, [activeTab, getpaymentData]);

  const handlePaymentMethodChange = (e) => {
    const selectedId = e.target.value;
    const selectedMethod = PaymentMethod.find(
      (payment) => payment.id === parseInt(selectedId),
    );

    // Set selected payment method to be used later
    setSelectedPaymentMethod(selectedMethod);

    // Reset ccnumber when payment method changes (optional, based on your requirements)
    setCcnumber("");
  };

  const handlePaySubmit = async (data) => {
    console.log("Pateintid", data.patientid);
    if (!selectedPaymentMethod) {
      setAlertMessage("Please Select Payment Method");
      setSeverity("warning");
      setOpen(true);
      return;
    }
    setLoading(true);

    const payload = {
      department_id: 1,
      patientname: `${data.firstname} ${data.lastname}`,
      appointmentid: data.appointmentid,
      amount: totalAmount,
      paymentmethodid: selectedPaymentMethod.id, // Payment Method ID
      paymentmethod: selectedPaymentMethod.type, // Payment Method Name
      ccnumber: ccnumber, // Example data
      paymentstatus: "success",
      paymentlocation: "Practice App",
      paymenttype: selectedPaymentMethod.type, // Payment Type
      // copay: copay,
      // paymentonaccount: paymentOnAccount,
      insurance: data.insurancename,
      // selfpay: selfPay,
      createdby: loginUser,
    };
    if (selfPay) {
      payload.selfpay = selfPay;
    }
    if (copay) {
      payload.copay = copay;
    }
    if (paymentOnAccount) {
      payload.paymentonaccount = paymentOnAccount;
    }
    try {
      const response = await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/payments/take-payments`,
        payload,
      );
      if (response.status === 200) {
        dispatch(
          showToast({
            message: "Payment processed successfully",
            severity: "success",
          }),
        );

        closeAllModals(0);
      } else {
        setAlertMessage(response.message);
        setSeverity("info");
        setOpen(true);

        navigate("/landing"); // Navigate after 2 seconds
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePay = async (data) => {
    const formattedStartDate = dayjs(data.startdate).format("YYYY-MM-DD");
    setLoading(true);
    const payload = {
      patientname: `${data.firstname} ${data.lastname}`,
      appointmentid: data.appointmentid,
      location: "Practice App",
      insurance: data.insurancename,
      copay: copay || 0.0,
      accountbalance: paymentOnAccount || 0.0,
      deductibleamt: deductible || 0.0,
      coinsurancepercent: coinsurance || 0.0,
      selfpaybalance: selfPay || 0.0,
      amount: totalAmount || 0.0,
      searchdate: formattedStartDate,
      createdby: loginUser,
    };

    try {
      const response = await api.put(
        `/v1/${practiseid}/patient/${data.patientid}/payments/updatepaymentupdate`,
        payload,
      );
      if (response.status === 200) {
        dispatch(
          showToast({
            message: response.message,
            severity: "success",
          }),
        );

        closeAllModals(0);
      } else {
        setAlertMessage(response.message);
        setSeverity("info");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatus = async (selectedColor) => {
    const formattedStartDate = dayjs(data.startdate).format("YYYY-MM-DD");

    const payload = {
      patient_name: `${data.firstname} ${data.lastname}`,
      appointmentid: data.appointmentid,
      amount: selectedColor,
      type: "dele",
      searchdate: formattedStartDate,
      createdby: loginUser,
    };

    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${data.patientid}/payment/update`,
        payload,
      );
      if (response.status === 200) {
        // setAlertMessage(response.message)
        // setSeverity("success")
        // setOpen(true)
      } else {
        // setAlertMessage(response.message)
        // setSeverity("info")
        // setOpen(true)
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    }
  };

  const handleCheckboxChange = (color, tabName) => {
    if (color === "F3082C"||tabName==="Coinsurance") {
      setSelectedColor(color);
      setSelectedTab(tabName);
      setInsuranceModalOpen(true);
      return;
    }

    // normal flow
    if (selectedColor === color) {
      setSelectedColor("");
      setSelectedTab("");
    } else {
      setSelectedColor(color);
      setSelectedTab(tabName);
    }

    handleStatus(color); // only for covered/coinsurance
  };
  const handleInsuranceSave = async (plans) => {
    setInsuranceModalOpen(false);
    setSelectedPlans(plans);

    const formattedStartDate = dayjs(data.startdate).format("YYYY-MM-DD");

    const payload = {
      patient_name: `${data.firstname} ${data.lastname}`,
      appointmentid: data.appointmentid,
      amount: "F3082C",
      type: "dele",
      searchdate: formattedStartDate,
      createdby: loginUser,
    };

    payload.insuranceCoveredPlan = plans;

    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${data.patientid}/payment/update`,
        payload,
      );

      if (response.status === 200) {
        handleGetPayment({ data });
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (activeTab === "payment") {
      setCopay("");
      setSelfPay("");
      setPaymentOnAccount("");
      setCoinsurance("");
      setDeductible("");
      setTotalAmount("0");
    } else if (activeTab === "update") {
      // Optionally reset these when switching to the update tab as well.
      setCopay("");
      setSelfPay("");
      setPaymentOnAccount("");
      setCoinsurance("");
      setDeductible("");
      setTotalAmount("0");
    }
  }, [activeTab]);

  const handleGetpreviousPayment = async ({ data }) => {
    setLoading(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/appointments/${data?.patientid}/update-deductible`,
      );

      if (response.status == 200) {
        setAlertMessage("Payments retrieved successfully");
        setSeverity("success");
        setOpen(true);
        handleGetPayment({ data: data });
      } else {
        setAlertMessage(response.message);
        setSeverity("info");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error fetching payment:", error);
      setAlertMessage("something went wrong");
      setSeverity("error");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg lg:w-[35%] w-[80%]">
        <div className="w-full justify-between flex border-b mb-2">
          <div className="flex gap-4">
            <h2 className="text-xl font-semibold text-[#09090B]">Payment</h2>
            <div className="mx-2 cursor-pointer" onClick={hanldeFrontdeskModal}>
              {frontDesk === "N" ? (
                <PersonalVideoIcon />
              ) : (
                <img src={cancelledDesk} className="mt-2" alt="%$" />
              )}
            </div>
          </div>

          <ClearIcon
            onClick={() => {
               setPrevamount('')
              closeAllModals(0);
            }}
            className="cursor-pointer"
          />
        </div>

        {/* Tab Buttons */}
        <div className="flex bg-gray-100 rounded-lg p-2 gap-1">
          <button
            className={`py-2 px-4 text-[14px] font-inter outline-none w-full text-center ${activeTab === "payment" ? "text-black bg-[white] border-none" : "text-gray-400"}`}
            onClick={() => setActiveTab("payment")}
          >
            Patient Responsibility
          </button>
          <button
            className={`py-2 px-4 text-[14px] font-font1 outline-none w-full text-center ${activeTab === "update" ? "text-black bg-[white] border-none" : "text-gray-400"}`}
            onClick={() => setActiveTab("update")}
          >
            Pay
          </button>
        </div>

        {/* Tab Content */}
        <div className="mt-4">
          {/* Payment Tab Content */}
          {activeTab === "payment" && (
            <div>
              <div className="mt-4 flex gap-4 justify-center">
                <div
                  className={`flex items-center flex-column border-2 rounded px-2 ${selectedColor === "58D68D" ? "border-green-500" : "border-gray-300"}`}
                  onClick={() => handleCheckboxChange("58D68D", "Covered")}
                >
                  <input
                    className="w-4 h-4 peer appearance-none mt-1 rounded-full border-2 border-gray-300 checked:bg-green-500 ring-2 ring-white"
                    name="updateOption"
                    id="option1"
                    type="checkbox"
                    checked
                  />
                  <label className="block text-sm font-medium mb-1 text-[#71717A]">
                    Covered
                  </label>
                </div>
                <div
                  className={`flex items-center flex-column border-2 rounded px-2 ${selectedColor === "F9E79F" ? "border-[#F59E0B]" : "border-gray-300"}`}
                  onClick={() => handleCheckboxChange("F9E79F", "Coinsurance")}
                >
                  <input
                    className="w-4 h-4 peer mt-1 appearance-none rounded-full border-2 border-gray-300 checked:bg-[#F59E0B] ring-2 ring-white"
                    name="updateOption"
                    id="option1"
                    type="checkbox"
                    checked
                  />
                  <label className="block text-sm font-medium mb-1 text-[#71717A]">
                    Coinsurance
                  </label>
                </div>
                <div
                  className={`flex items-center flex-column border-2 rounded px-2 ${selectedColor === "F3082C" ? "border-[#F43F5E]" : "border-gray-300"}`}
                  onClick={() => handleCheckboxChange("F3082C", "Deductible")}
                >
                  <input
                    className="w-4 h-4 peer mt-1 appearance-none rounded-full border-2 border-gray-300 checked:bg-[#F43F5E] ring-2 ring-white"
                    name="updateOption"
                    id="option1"
                    type="checkbox"
                    checked
                  />
                  <label className="block text-sm font-medium mb-1 text-[#71717A]">
                    Deductible
                  </label>
                </div>
                {selectedTab?.length ? (
                  <div onClick={() => handleCheckboxChange("0", "")}>
                    <CloseIcon />
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
              <div className="grid grid-cols-1 gap-4 mt-4">
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-medium font-semibold font-inter mb-1">
                    Co-pay
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="%$" />
                    </span>
                    <input
                      value={copay}
                      onChange={(e) => setCopay(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">
                    Balance
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="%$" />
                    </span>{" "}
                    <input
                      value={paymentOnAccount}
                      onChange={(e) => setPaymentOnAccount(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">
                    Deductible
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="%$" />
                    </span>
                    <input
                      value={deductible}
                      onChange={(e) => setDeductible(e.target.value)}
                      type="number"
                      disabled={
                          !(
      data?.visit_confirmation === "" ||
      data?.visit_confirmation === "visit_confirmation" ||
      data?.visit_confirmation === "Tele - Confirmed"
    )
                      }
                      className={`w-full border-none outline-none px-1 ${
                        !(
      data?.visit_confirmation === "" ||
      data?.visit_confirmation === "visit_confirmation" ||
      data?.visit_confirmation === "Tele - Confirmed"
    )
                          ? "cursor-not-allowed"
                          : ""
                      }`}
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">
                    Self Pay
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="%$" />
                    </span>{" "}
                    <input
                      value={selfPay}
                      onChange={(e) => setSelfPay(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">
                    Total
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm"></span>
                    <input
                      value={totalAmount}
                      onChange={(e) => setTotalAmount(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                {selectedTab === "Coinsurance" && (
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter mb-1">
                      Co-Insurance
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-md font-inter text-gray-500">
                        %
                      </span>
                      <input
                        value={coinsurance}
                        onChange={(e) => setCoinsurance(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                )}
              </div>
                    {/* {getpaymentData?.copay ?<div className="text-sm mt-2 text-start font-semibold text-[#71717A]">
  Total: ${getpaymentData?.copay }
</div>:<></>} */}
              <div className="mt-2 flex flex-column gap-2 text-left">
                <div className="text-sm font-semibold text-[#71717A]">
                  {data.insurancename}
                </div>
                <div className="">
                  <div
                    onClick={() => {
                      handleGetpreviousPayment({ data: data });
                    }}
                    className="inline-flex items-center gap-2 cursor-pointer px-4 py-2 rounded-[22px] bg-white shadow-[0_0_4px_rgba(0,0,0,0.25)]"
                  >
                    {retrive}
                    <span>Retrieve last visit</span>
                  </div>
                </div>

                <button
                  onClick={() => handleUpdatePay(data)}
                  disabled={loading}
                  className="w-full py-2 bg-black text-white rounded-lg flex items-center justify-center"
                >
                  {loading ? (
                    <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                  ) : (
                    "Update Payment"
                  )}
                </button>
              </div>
            </div>
          )}

          {/* Update Tab Content */}
          {activeTab === "update" && (
            <div>
           {Array.isArray(prevamount) && prevamount.length > 0 ? (
              <div className="flex justify-center items-center ">
          
          
            <div className="text-center flex items-center font-bold text-[#71717A]">
              Amount Paid: ${prevamount[0].amount} on{" "}
              {new Date(prevamount[0].payment_date).toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              })}
          {prevamount.length > 1 && (
            <FontAwesomeIcon
              icon={faEye}
              className="ml-2 text-[#71717A] cursor-pointer"
              onClick={() => setShowPaymentsHistory(true)}
            />
          )}
            </div>
          
              </div>
          
          ) : null}
              <div className="text-[17px] font-inter mb-1 text-left">
                Payment method
              </div>
              <div className="flex gap-4 justify-between flex-col items-center mt-2 mb-2">
                <select
                  onChange={handlePaymentMethodChange}
                  className="border rounded-lg px-2 py-2 w-[100%]"
                >
                  <option value="">Select Payment method</option>
                  {loading ? (
                    <option disabled>Loading...</option>
                  ) : (
                    PaymentMethod.map((payment) => (
                      <option key={payment.id} value={payment.id}>
                        {payment.method}
                      </option>
                    ))
                  )}
                </select>
                {selectedPaymentMethod &&
                  !(selectedPaymentMethod.method === "CASH") && (
                    <div className="w-full">
                      <label className="block mb-1 my-0 text-left">
                        {" "}
                        {selectedPaymentMethod.method === "CHECK"
                          ? "Check Number"
                          : "Enter 4-digit number"}
                      </label>
                      <input
                        type="text"
                        value={ccnumber}
                        onChange={(e) => setCcnumber(e.target.value)}
                        maxLength="4"
                        pattern="[0-9]{4}"
                        placeholder="4 digits"
                        className="border rounded-lg px-2 py-1  w-[100%]"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  )}
              </div>

              <p className="text-[16px]  font-semibold mb-2 text-left">
                Payment Type
              </p>
              <div className="grid grid-cols-1 gap-4 mt-1">
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-medium font-semibold font-inter mb-1">
                    Co-pay
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="%$" />
                    </span>
                    <input
                      value={copay}
                      onChange={(e) => setCopay(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-medium font-semibold font-inter mb-1">
                    Self Pay
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="%$" />
                    </span>{" "}
                    <input
                      value={selfPay}
                      onChange={(e) => setSelfPay(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-medium font-semibold font-inter mb-1 w-[80px] text-left">
                    Payment on Account
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="%$" />
                    </span>
                    <input
                      value={paymentOnAccount}
                      onChange={(e) => setPaymentOnAccount(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>

                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-medium font-semibold font-inter mb-1">
                    Total Amount
                  </label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="%$" />
                    </span>
                    <input
                      value={totalAmount}
                      onChange={(e) => setTotalAmount(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-6 flex flex-column gap-2 text-left">
                <div className="text-sm font-semibold text-[#71717A] mt-1">
                  {data.insurancename}
                </div>

                <button
                  onClick={() => handlePaySubmit(data)}
                  disabled={loading}
                  className="w-full py-2 bg-black text-white rounded-lg flex items-center justify-center"
                >
                  {loading ? (
                    <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                  ) : (
                    "Pay"
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {frontdeskModal && (
        <ConfirmFrontdesk
          handleFrontDeskToggle={handleFrontDeskToggle}
          setfrontdeskModal={setfrontdeskModal}
        />
      )}
      {insuranceModalOpen && (
        <InsurancePlansModal
          open={insuranceModalOpen}
          preSelected={selectedPlans}
          onClose={() => setInsuranceModalOpen(false)}
          onSave={handleInsuranceSave}
        />
      )}
        {showPaymentsHistory && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 p-3 sm:p-4">
          
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[80vh] flex flex-col">
      
            {/* Header */}
            <div className="flex justify-between items-center border-b px-3 py-2 sm:px-4 sm:py-3">
              <h3 className="font-semibold text-base sm:text-lg">
                Payment History
              </h3>
              <CloseIcon
                className="cursor-pointer text-gray-600"
                onClick={() => setShowPaymentsHistory(false)}
              />
            </div>
      
            {/* Payments list */}
            <div className="overflow-y-auto px-3 py-2 sm:px-4 sm:py-3 space-y-2 flex-1">
      
              {prevamount.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center border rounded-md px-2 py-2 sm:px-3"
                >
                  <div className="text-xs sm:text-sm text-gray-600">
                    {new Date(item.payment_date).toLocaleDateString("en-US", {
                      month: "2-digit",
                      day: "2-digit",
                      year: "numeric",
                    })}
                  </div>
      
                  <div className="font-semibold text-sm sm:text-base text-gray-800">
                    ${item.amount}
                  </div>
                </div>
              ))}
      
            </div>
      
          </div>
        </div>
      )}
  <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handlealert}
      />
    </div>
  );
};

export default Payment;
